/**
 * DimensionSubtype enum defines the sub types of the Dimensional Field.
 *
 * @readonly
 * @enum {string}
 */
const DimensionSubtype = {
    CATEGORICAL: 'categorical',
    TEMPORAL: 'temporal',
    GEO: 'geo',
    BINNED: 'binned'
};

export default DimensionSubtype;
